module.exports = __webpack_public_path__ + "img/9.45c774b4.png";